import React, { useState, useEffect } from 'react';
import State from "../State";
import './SunChart.css';
import SunChartService from "./SunChartService";
import {gql, useMutation, useQuery} from "@apollo/client";
import BreadCrumbs from "../BreadCrumbs/BreadCrumbs";


export default function SunChartInvoiceRegistration({ jsonServer, apikey}) {

	const [state] = useState(new State(useState(0)));

	const service = new SunChartService(jsonServer, state);

	const [callCreatePowerMonth, { }] = useMutation(service.CREATE_POWER_MONTH_MUTATION, {
		variables: { },
		onCompleted: data => {
			service.createResponse(data)
		},
		onError: data => {
			state.setError('Creating power month failed')
			console.log('Creating power month failed');
		}
	});

	const [callUpdatePowerMonth, {  }] = useMutation(service.UPDATE_POWER_MONTH_MUTATION, {
		variables: { },
		onCompleted: data => {
			service.updateResponse(data)
		},
		onError: data => {
			state.setError('Updating power month failed')
			console.log('Updating power month failed');
		}
	});

	const  { } = useQuery(service.POWER_MONTH_QUERY, {
		variables: { path: state.queryPath },
//			fetchPolicy: "no-cache",
		onCompleted: data => {
			service.powerMonthRead(data.getPowerMonth)
		},
		onError: data => {
			service.powerMonthRead(null)
		}
	});

	let currentType = '';

	return (
		<div>
			<BreadCrumbs path={[{link: "/", title:"Hem"}, {link: "/sunchart", title:"Solenergi"}]} title="Fakturainmatning" />
			<span className='error'>{state.error}</span><span className='message'>{state.message}</span>
			<h1>Registrera faktura</h1>
			Klistra in kopierad data för tolkning:<br/>
			<textarea id="parseInput" cols="60" value={state.parseArea || ''} onChange={(e) => {
				service.parseInput(e.target.value)
			}}></textarea><span className="clearicon" onClick={() => {
			service.clearInputStates()
		}}>🆑</span>
			<br/>

			<table>
				<tbody>
				<tr key="headline">
					<th key="label_header"></th>
					<th key="date_header">Datum</th>
					<th key="quantity_header">Antal</th>
					<th key="price_header">Pris</th>
					<th key="sum_header">Summa</th>
				</tr>
				{ // {'date': '', 'amount': '', 'price': '', 'sum': ''}
					service.fields.map(f => {
							const isNew = currentType !== f.type;
							currentType = f.type;
							return (
								<>
									{isNew ? (<tr key={f.type}>
										<td><b>{service.types[f.type].name}</b></td>
									</tr>) : ''}
									<tr key={f.name}>
										<td key={f.name + '_label'}>{f.label}</td>
										{Object.keys(service.emptyRow).map(d => (
											<td key={f.name + '_' + d}><input id={f.name + '_' + d} type="text" value={state.get(f.name)[d]}
													   onChange={(e) => {
														   service.setValue(f.name, d, e.target.value)
													   }}/> {d === 'amount' ? f.unit : (d === 'price' ? f.priceUnit : (d === 'sum' ? 'kr' : ''))}
											</td>
										))}

									</tr>
								</>)
						}
					)
				}

				</tbody>
			</table>

			{
				Object.keys(service.types).map(type => {
					const t = state.get(type)
					return (<><input key={'vat_' + t.type} type="checkbox" checked={t.incVat}
									 onChange={event => service.setVatType(t.type, event.target.checked)}/> {t.name} ink.
						moms <br/></>)
				})
			}
			<span className="clearicon" onClick={() => {
				service.clearFields()
			}}>🆑</span>
			<br/>
			<button onClick={() => {
				service.clearMessages();
				if (service.doCreate()) {
					callCreatePowerMonth(service.getCreateOptions())
				}
				else {
					callUpdatePowerMonth(service.getUpdateOptions())
				}
			}}>Spara</button>
			<br/>
			<dl>
				{
					service.POWER_MONTH_ATTRIBUTES.map(a =>
						(<dt key={a}>{a}: {state.powerMonth[a]}</dt>))
				}
			</dl>
		</div>
	);
}

